import React, { PropTypes, Component } from 'react';
import { AuthStore } from 'stores';
import shallowEqual from 'shallowequal';
import * as utils from 'Util';
import ProfileHeader from './ProfileHeader';

export default class ProfileImageContainer extends utils.mixin(
  utils.RefluxMixin,
  Component
) {
  static displayName = 'ProfileHeaderContainer';

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !shallowEqual(this.props, nextProps) ||
      !shallowEqual(this.state, nextState)
    );
  }

  listenToStores() {
    this.listenToStore(AuthStore);
  }

  render() {
    return <ProfileHeader author={this.state} />;
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/ProfileHeaderContainer.js